/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Ceiling_HeightInputs */

const cs_form_ceiling_height = /** @type {(inputs: Form_Ceiling_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výška stropu (m)`)
};

const en_form_ceiling_height = /** @type {(inputs: Form_Ceiling_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceiling height (m)`)
};

/**
* | output |
* | --- |
* | "Ceiling height (m)" |
*
* @param {Form_Ceiling_HeightInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_ceiling_height = /** @type {((inputs?: Form_Ceiling_HeightInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Ceiling_HeightInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_ceiling_height(inputs)
	return cs_form_ceiling_height(inputs)
});